import React, { useEffect, useCallback } from 'react';
import noop from '../utils/noop';
import constants from './constants';
import createRoundedRectPath from './helpers/create-rounded-rect-path';

const { ESCAPE_CODE } = constants;

function Overlay({ elementBounds, onOverLayClick = noop, borderRadius }) {
  const handleKeyPress = useCallback(
    (e) => {
      const { code } = e;
      if (code === ESCAPE_CODE) {
        onOverLayClick();
      }
    },
    [onOverLayClick]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleKeyPress]);

  const { left, top, width, height } = elementBounds;
  const cutoutPath = createRoundedRectPath({ x: left, y: top, width, height, radii: borderRadius });

  return (
    <div className="ws-focal-point__overlay">
      <svg className="ws-focal-point__svg" onClick={onOverLayClick}>
        <defs>
          <mask id="substract">
            <rect width="100%" height="100%" fill="white" />
            <path d={cutoutPath} fill="black" />
          </mask>
        </defs>
        <rect
          className="ws-focal-point__mask"
          x="0"
          y="0"
          width="100%"
          height="100%"
          mask="url(#substract)"
        />
      </svg>
    </div>
  );
}

export default Overlay;
